// extracted by mini-css-extract-plugin
export default {"descriptionEditor":"HtmlEditor_descriptionEditor__LyX4w","disabled":"HtmlEditor_disabled__jmHOT"};